// THE SHAPE OF EVERY SHOT, 9:16, wherever it is drawn: the published tutorial on a phone and on a
// desktop, and the Phase 6 viewport it is framed in. The camera keeps its vertical angle and the
// width follows the box, so the same pose in a box of the same shape is the same picture, at the
// same zoom, at any size. A wider box showed more around the parts than the reader would ever see
// (Louis 2026-10-28).
//
// TWICE, AS A CLASS AND AS A NUMBER, side by side: Tailwind finds a class only where it is written
// out whole, and the rules that work out a shot's zoom need the width over the height (see
// movementShot). They framed for a picture 1.8 times as wide as tall long after it stopped being
// one, and cut the screwdriver off at the edge (Louis 2026-10-28).
export const SHOT_ASPECT = 'aspect-[9/16]';
export const SHOT_RATIO = 9 / 16;
